var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.665,
    viewBox: "0 0 18 15.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_note_FILL1_wght700_GRAD0_opsz20",
    d: "M158-790.324v-2.87h8.489v2.87Zm0-4.4v-2.87h11.627v2.87Zm0-4.4V-802h11.627v2.87Zm8.854,12.795v-3.43l5.254-5.23a1.507,1.507,0,0,1,.555-.372,1.718,1.718,0,0,1,.607-.115,1.656,1.656,0,0,1,.629.122,1.651,1.651,0,0,1,.544.365l1.07,1.095a1.92,1.92,0,0,1,.358.555,1.55,1.55,0,0,1,.129.607,1.7,1.7,0,0,1-.117.63,1.557,1.557,0,0,1-.37.543l-5.23,5.23Zm6.641-5.522.851-.876-1.095-1.095-.851.876Z",
    transform: "translate(-158 802)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNote);
export default __webpack_public_path__ + "static/media/editNote.6912159c60ac156149bba597d3c1e58c.svg";
export { ForwardRef as ReactComponent };